// @flow
/* eslint-disable react/no-did-mount-set-state */
import * as React from 'react';
import { useEffect, useState } from 'react';

type Props = { children: React.Node };

/**
 * Helper component that only renders clientSide, using react component
 * uses useEffect to detect if this is clientSide or serverSide
 * useEffect only called in browser
 */

const ClientSide = ({ children }: Props) => {
  const [show, setShow] = useState(false);

  useEffect(
    () => {
      setShow(true);
    },
    [setShow]
  );

  if (!show) {
    return <div />;
  }
  return children;
};

export default ClientSide;
